import styled from 'styled-components'
import { SubscriptionType } from '../../../types'
import { YEAR, TRIAL } from '../../utils/stripePrices'

type StyledProps = {
  value: SubscriptionType;
}

const StyledSubscriptionSelect = styled.div<StyledProps>`
  background: linear-gradient(
    135deg,
    rgba(249, 225, 180, 0.2) 2.88%,
    rgba(182, 224, 245, 0.2) 100%
  );
  border-radius: 3px;
  padding: 1rem;
  display: grid;
  grid-gap: 8px;

  .subscription-benefits {
    display: grid;
    grid-gap: 6px;
    padding: 0;
    margin-bottom: 10px;

    .annual-sep {
      display: flex;
      font-weight: 700;
      font-size: 14px;
      align-items: center;
      padding-left: 40px;
      margin-top: 10px;
      color: ${({ theme }) => theme.colors.green[300]};

      svg {
        height: 20px;
        margin-left: 7px;
      }
    }

    li {
      display: flex;
      font-weight: 600;
      align-items: center;
      font-size: 15px;
      color: ${({ theme }) => theme.colors.gray[700]};

      svg {
        margin-right: 1rem;
        height: 24px;
      }
    }

    .annual {
      color: ${({ value, theme }) =>
    (value?.id === YEAR ? theme.colors.gray[700] : theme.colors.gray[300])};
    }

    .paid-subscription {
      color: ${({ value, theme }) =>
    (value?.id === TRIAL ? theme.colors.gray[300] : theme.colors.gray[700])};
    }
  }
`

export default StyledSubscriptionSelect
